import React, { Component } from 'react'

import Product from '../block/Product'
import Oblast from '../block/Oblast'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Product data={data} />
        <Oblast data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App